// FitX uses the Rails JSON API. Materio's MSW demo fake-api is disabled.
export default function () {}
